import React from "react";
import { CloudUpload } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import {
  useGetBookingFilesQuery,
  GetBookingFiles,
  BookingEventLog_GetEvents,
  useDeleteBookingDocMutation
} from "@graphql";
import { SecondaryButton } from "@components";
import DocumentList from "@containers/DocumentList/DocumentList";

type Props = {
  id: string;
  onUpload: () => void;
};

export function BookingDocuments({ id, onUpload }: Props) {
  const { data, loading } = useGetBookingFilesQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      id
    }
  });
  const [deleteDoc] = useDeleteBookingDocMutation();
  const handleDelete = (doc) => {
    deleteDoc({
      variables: {
        id: data.bookingById._id,
        fileId: doc.FileRef.NodeID
      },
      refetchQueries: [
        GetBookingFiles.OperationName,
        BookingEventLog_GetEvents.OperationName
      ]
    });
  };

  return (
    <div>
      <div style={{ display: "flex", marginBottom: 16 }}>
        <SecondaryButton
          onClick={onUpload}
          variant="outlined"
          leftIcon={<CloudUpload />}
          style={{ marginLeft: "auto" }}
        >
          {locale.UploadFile}
        </SecondaryButton>
      </div>

      <DocumentList
        loading={loading}
        groupBy={(d) => locale.bookingWeekDocumentTypes[d.DocumentType]}
        documents={data?.bookingById.attachments || []}
        onDelete={handleDelete}
      />
    </div>
  );
}
